module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_phone-f133cb3cebc40aa5355f67ad22613584.svg";